module.exports = __webpack_public_path__ + "static/media/cup-hex.c7114d80.svg";